module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAAXNSR0IArs4c6QAAAHpJREFUKBVjDG77/5+BAGBiYCheXcXYB1dGSBNIPrj9/62Qjv9lME1AQwgDViYGB4b/DElAjVUg1URpWlHO+IyRmcEB6JGY0I7/dSyE7WFgADnx3x+Iyn//GRrBAsRohKkBGUCU82AaYPSoJmhIDPKAYCSUymERikwDAKZQKp6HSLLuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon__paper--blue.png
// module id = HbNI
// module chunks = 1